import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { DockerHubConfigurationItem } from "./DockerHubConfigurationItem"

import type { DockerHubConfiguration } from "@/api/useIntegrations.types"
import type { DockerHubConfigurationTabProps } from "."

export const DockerHubConfigurationTab = (
  props: DockerHubConfigurationTabProps
) => {
  const { t } = useTranslation()
  const [data] = useIntegration(props)
  const configuration = data?.configuration as
    DockerHubConfiguration | undefined
  const accounts = configuration?.installations || []

  if (!accounts.length) return <>{t("integrations.dockerHub.noData")}</>

  return (
    <Flex vertical gap={8}>
      {accounts.map((account) => (
        <DockerHubConfigurationItem
          key={account.accountId}
          account={account}
          {...props}
        />
      ))}
    </Flex>
  )
}
